// extracted by mini-css-extract-plugin
module.exports = {"HeaderHeight":"110px","AnnouncementHeight":"40px","SidebarWidth":"330px","wrapper":"src-components-Breadcrumb---wrapper---Tp-QA","icon":"src-components-Breadcrumb---icon---1ikw5"};